/* @flow */

export {ConfirmationDialog} from './confirmation-dialog';
